import { ItemEntity } from '@entities/Item/Types';

export const GetItemsTotalPrice = (items: ItemEntity[]) => {
    return items.reduce((total, item) => {
        if (item && item.qty && item.qty > 0) {
            const price = item.price;
            const formattedPrice = price ?? 0;
            return total + item.qty * formattedPrice;
        }
        return total;
    }, 0);
};
